// extracted by css-extract-rspack-plugin
export default {"icon":"product-detail-fragment__ProductParticipants_icon__9RATd"};